import styles from 'styles/views/widgets/EventInsight.css';
import React from 'react';
import classnames from 'classnames';

const EventInsight = ({ eventconversionrate, overallconversionrate, mobileVersion,
  totalrevenue, isrrevenue, type }) => {
  const formatter = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'});
  // use ISR revenue if applicable
  const rev = (typeof isrrevenue !== 'undefined' && isrrevenue > 0)?isrrevenue : totalrevenue;
  return (
    <div className={classnames(styles.content, {[styles.mobileInsight]: mobileVersion})}>
      <div className={styles.totalRevenue}>
        <span className={styles.revenueText}>{formatter.format(rev)}</span>
      </div>
      <div className={styles.eventConversion}>
        <span>{`${type} & Converted`}</span>
        <span className={styles.bold}>{`${eventconversionrate}%`}</span>
      </div>
      <div className={styles.overallConversion}>
        <span>{'Overall Conversion Rate'}</span>
        <span className={styles.bold}>{`${overallconversionrate}%`}</span>
      </div>
    </div>
  );
};

export default EventInsight;



/** WEBPACK FOOTER **
 ** ./src/views/widgets/EventInsight.js
 **/